(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Body scroll lock (position:fixed) reports scrollTop as 0; without this guard, hide/reveal logic
      // calls reset() and strips sticky positioning — header jumps to document top (hero) while drawer stays wrong.
      if (this.header.classList.contains('menu-open')) return;
      if (document.body.dataset.scrollLocked === 'true') return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class ListicleStickyCta extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 500;
      this.dismissed = false;
      this._onScroll = this._onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      const dismiss = this.querySelector('.listicle-sticky__dismiss');
      if (dismiss) {
        dismiss.addEventListener('click', () => { this.dismissed = true; this._hide(); });
      }
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      document.body.classList.remove('listicle-bar-active');
    }

    _onScroll() {
      if (this.dismissed) return;
      if (window.scrollY > this.threshold) { this._show(); } else { this._hide(); }
    }

    _show() {
      this.classList.add('is-visible');
      document.body.classList.add('listicle-bar-active');
    }

    _hide() {
      this.classList.remove('is-visible');
      document.body.classList.remove('listicle-bar-active');
    }
  }

  if (!customElements.get('listicle-sticky-cta')) {
    customElements.define('listicle-sticky-cta', ListicleStickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-new-buy-box"]) return;
  try {
    
  (function () {
    function isV3BuyBoxPage() {
      return !!document.querySelector('.product-nw-v2-new-buy-box');
    }

    function getFirstMediaItem(sliderRoot) {
      return sliderRoot.querySelector('.product__media-list > .product__media-item');
    }

    function syncMainImageArrowsToHero(sliderRoot) {
      const arrows = sliderRoot.querySelector('.product__main-image-arrows');
      const firstMediaItem = getFirstMediaItem(sliderRoot);
      if (!arrows || !firstMediaItem) return;

      const sliderRect = sliderRoot.getBoundingClientRect();
      const mediaRect = firstMediaItem.getBoundingClientRect();
      if (!sliderRect.height || !mediaRect.height) return;

      const mediaTop = Math.max(0, mediaRect.top - sliderRect.top);
      arrows.style.setProperty('--hero-media-top', mediaTop + 'px');
      arrows.style.setProperty('--hero-media-height', mediaRect.height + 'px');
    }

    function mountFlockArmorV2ArrowPositioning() {
      if (!isV3BuyBoxPage()) return;

      const sliderRoots = document.querySelectorAll(
        '.product-nw-v2-new-buy-box .product__media-wrapper .slider-mobile-gutter'
      );
      if (!sliderRoots.length) return;

      sliderRoots.forEach((sliderRoot) => {
        syncMainImageArrowsToHero(sliderRoot);
      });

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          sliderRoots.forEach(syncMainImageArrowsToHero);
        }, 80);
      });

      setTimeout(() => sliderRoots.forEach(syncMainImageArrowsToHero), 120);
      setTimeout(() => sliderRoots.forEach(syncMainImageArrowsToHero), 420);
    }

    function underlineFlockArmorV2LooxReviews() {
      if (!isV3BuyBoxPage()) return;

      const labels = document.querySelectorAll('.loox-rating-label');
      if (!labels.length) return;

      labels.forEach((label) => {
        if (label.dataset.reviewsUnderlineApplied === 'true') return;

        const rawText = (label.textContent || '').replace(/\s+/g, ' ').trim();
        const separatorIndex = rawText.indexOf('|');
        if (separatorIndex === -1) return;

        const leftText = rawText.slice(0, separatorIndex).trim();
        const rightText = rawText.slice(separatorIndex + 1).trim();
        if (!leftText || !rightText) return;

        label.textContent = '';
        label.appendChild(document.createTextNode(leftText + ' | '));

        const underlinedReviews = document.createElement('span');
        underlinedReviews.style.textDecoration = 'underline';
        underlinedReviews.textContent = rightText;
        label.appendChild(underlinedReviews);
        label.dataset.reviewsUnderlineApplied = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountFlockArmorV2ArrowPositioning);
      document.addEventListener('DOMContentLoaded', underlineFlockArmorV2LooxReviews);
    } else {
      mountFlockArmorV2ArrowPositioning();
      underlineFlockArmorV2LooxReviews();
    }

    setTimeout(underlineFlockArmorV2LooxReviews, 300);
    setTimeout(underlineFlockArmorV2LooxReviews, 900);
    setTimeout(underlineFlockArmorV2LooxReviews, 1800);
  })();

  } catch(e) { console.error(e); }
})();
})();
